<template>
  <v-btn
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="success"
      @click="init"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <v-icon>
      mdi-plus
    </v-icon>

    <slot/>

    <v-dialog
        v-model="dialog"
        :persistent="true"
        :scrollable="true"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          Vytvoriť mutáciu

          <v-spacer/>

          <v-btn
              :icon="true"
              color="default"
              @click="closeDialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
              @submit.stop.prevent="submit"
          >
            <v-row>
              <v-col
                  cols="12"
              >
                <ImageFiles
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Vlajka"
                    :persistent-hint="true"
                    hint="Odporúčaný formát 4:3"
                    :File="MutationForm.Flag"
                    :errorsFile="errors.Flag"
                    @setFile="setFlag"
                />
              </v-col>

              <v-col
                  cols="12"
                  lg="9"
              >
                <v-text-field
                    v-model="MutationForm.title"
                    :error-messages="errors.title"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Názov"
                />
              </v-col>

              <v-col
                  cols="12"
                  lg="3"
              >
                <v-text-field
                    v-model="MutationForm.iso"
                    :error-messages="errors.iso"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="ISO"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-btn
                    type="submit"
                    :rounded="true"
                    :outlined="true"
                    :loading="loading"
                    :disabled="loading"
                    color="success"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>

                  Vytvoriť
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import Mutations from '@/services/mutations'

  import ImageFiles from '@/components/Files/Image'

  export default {
    name: 'Create',
    components: {
      ImageFiles
    },
    data() {
      return {
        loading: false,
        dialog: false,
        MutationForm: {},
        errors: {}
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      closeDialog() {
        this.dialog = false
      },
      loadData() {
        this.dialog = true

        this.MutationForm = {
          Flag: null,
          title: '',
          iso: ''
        }

        this.errors = {}
      },
      setFlag(Flag) {
        this.MutationForm.Flag = Flag
      },
      async submit() {
        this.loading = true

        await Mutations
          .create({
            data: this.MutationForm
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            this.closeDialog()

            this.$emit('init')
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
